import {
  Button,
  Checkbox,
  Grid,
  MenuItem,
  Stack,
  TextField,
  Tooltip,
} from "@mui/material";
import {Form, Formik } from "formik";
import React, {useEffect, useState} from "react";
import http from "../Http";
import "../assets/style/pages/Settings.scss";
import DashboardBox from "../components/DashboardBox";
import Loading from "../components/Loading";
import ColorPicker from "../components/formik/ColorPicker";
import Select from "../components/formik/Select";
import {
  DATA_ENDPOINTS,
  PROFILE_ENDPOINTS,
  SUBMIT_ENDPOINTS,
} from "../constants/Endpoints";
import {LOADING_TIME} from "../constants/Time";

export const getSettings = async () => {
  const settings = await http.get(PROFILE_ENDPOINTS.SETTINGS);
  await new Promise((r) => setTimeout(r, LOADING_TIME)); // Let the circle spin for LOADING_TIME milliseconds.
  return settings.data;
};

export default function Settings({setThemeColor}) {
  const [loading, setLoading] = useState(false);
  const [settings, setSettings] = useState({
    themeColor: null,
    allowSharing: null,
    classTemplate: null,
    linkStudentsInProfile: null,
    settingsLevels: null,
  });

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    setLoading(true);
    try {
      const response = await http.get(DATA_ENDPOINTS.SETTINGS);
      setSettings(response.data);
    } catch (_) {
    }
    setLoading(false);
  };

  const handleSubmit = (settings) => {
    http.put(SUBMIT_ENDPOINTS.SETTINGS.UPDATE, settings).then((_) => {
      loadSettings();
    });
  };

  return (
    <DashboardBox sx={{maxWidth: 400}}>
      <Stack direction="row" spacing={1} alignItems="center">
        <p className="title">Instellingen</p>
        {loading && <Loading size={20}/>}
      </Stack>
      {!loading && (
        <Formik initialValues={settings} onSubmit={handleSubmit}>
          {({ values, setFieldValue }) => (
            <Form>
              <Stack spacing={2}>
                <span style={{margin: "5px 0 -5px 0"}}>
                  <Checkbox style={{ width: "30px", padding:"0 5px 0 0" }}
                            checked={values.linkStudentsInProfile}
                    onChange={() => {
                      setFieldValue('linkStudentsInProfile', !values.linkStudentsInProfile);
                    }}
                  />
                  <span>Begeleiders kunnen zelf leerlingen koppelen via profiel</span>
                </span>
                <ColorPicker
                  hideTextfield
                  name="themeColor"
                  setThemeColor={setThemeColor}
                />
                <Select
                  name="classTemplate"
                  label="Klassencode"
                  value={settings.classTemplate ?? "YLN"}
                >
                  <MenuItem value="YLN">
                    Leerjaar + niveau + klasnummer (4H1)
                  </MenuItem>
                  <MenuItem value="YLC">
                    Leerjaar + niveau + klasletter (4HA)
                  </MenuItem>
                  <MenuItem value="LYN">
                    Niveau + leerjaar + klasnummer (H41)
                  </MenuItem>
                  <MenuItem value="LYC">
                    Niveau + leerjaar + klasletter (H4A)
                  </MenuItem>
                </Select>
                <h4>Niveau instellen</h4>
                <Grid container columns={{xs: 3}} rowSpacing={1}>
                  {settings.settingsLevels != null &&
                    settings.settingsLevels.map((level, i) => {
                      return (
                        <Grid item xs={1}>
                          <Stack direction="row">
                          <span>
                            <Checkbox
                              checked={level.active}
                              onChange={() => {
                                const newSettingsLevels =
                                  settings.settingsLevels;

                                newSettingsLevels[i].active = !level.active;

                                setSettings({
                                  ...settings,
                                  settingsLevels: newSettingsLevels,
                                });
                              }}
                            />
                            <Tooltip
                              title={
                                level.abbreviation === ""
                                  ? "De afkorting mag niet leeg zijn!"
                                  : level.levelName
                              }
                              arrow
                              disableInteractive
                            >
                              <TextField
                                label={level.levelName}
                                value={level.abbreviation}
                                variant="standard"
                                error={level.abbreviation === ""}
                                onChange={(e) => {
                                  const text = e.target.value;

                                  // Maximum of 5 characters for the abbreviation.
                                  if (text.length > 5) return;

                                  const newSettingsLevels =
                                    settings.settingsLevels;

                                  newSettingsLevels[i].abbreviation = text;

                                  setSettings({
                                    ...settings,
                                    settingsLevels: newSettingsLevels,
                                  });
                                }}
                                style={{width: "80px"}}
                              />
                            </Tooltip>
                          </span>
                          </Stack>
                        </Grid>
                      );
                    })}
                </Grid>
                <Stack direction="row" justifyContent="end">
                  <Button variant="contained" type="submit">
                    Opslaan
                  </Button>
                </Stack>
              </Stack>
            </Form>
          )}
        </Formik>
      )}
    </DashboardBox>
  );
}
